import $ from "jquery"

/**
 * Scripts for market section
 */
const marketItem = $('.js-markets-item');

marketItem.each(function(){
    $(this).on('click', function(){
        const marketItemLeftContent = $(this).children('.js-markets-description').html();

        $('.js-market-populate-link').show();
        $('.js-market-populate-content').html(marketItemLeftContent);
    });
});
